var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwardArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_14932)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_121_14932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.059 0.91855C10.4733 0.360483 9.52206 0.360483 8.93635 0.91855L1.43928 8.06181C0.853573 8.61987 0.853573 9.52617 1.43928 10.0842C2.02499 10.6423 2.97618 10.6423 3.56189 10.0842L8.50059 5.37416V19.0713C8.50059 19.8616 9.17064 20.5 10 20.5C10.8294 20.5 11.4994 19.8616 11.4994 19.0713L11.4994 5.37862L16.4381 10.0798C17.0238 10.6378 17.975 10.6378 18.5607 10.0798C19.1464 9.52171 19.1464 8.61541 18.5607 8.05734L11.0636 0.914085L11.059 0.91855Z",
    fill: "#222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_14932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 20.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_121_14932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 20.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrowIcon);
export default __webpack_public_path__ + "static/media/UpwardArrowIcon.de77c817af801bf0d66c7c1d5d3e6b22.svg";
export { ForwardRef as ReactComponent };